import React from 'react';
import { Check } from 'lucide-react';

const options = [
    { value: 'newgraduate', label: 'New Graduate' },
    { value: 'entrylevel', label: 'Entry-Level' },
    { value: 'associate', label: 'Associate' },
    { value: 'midsenior', label: 'Mid-Senior' },
    { value: 'director', label: 'Director' },
    { value: 'executive', label: 'Executive' },
];

const JobHeaderExperience = ({ selectedExperience = [], setSelectedExperience = () => {} }) => {
    const toggle = (value) => {
        setSelectedExperience(prev =>
            prev.includes(value)
                ? prev.filter(v => v !== value)
                : [...prev, value]
        );
    };

    return (
        <div className="flex flex-wrap gap-2">
            {options.map(opt => {
                const active = selectedExperience.includes(opt.value);
                return (
                    <button
                        key={opt.value}
                        type="button"
                        onClick={() => toggle(opt.value)}
                        className={`flex items-center gap-1.5 px-4 py-2 rounded-lg text-[13px] font-medium border transition-all ${
                            active
                                ? 'bg-[#EEF1FE] border-[#3F57E0] text-[#3F57E0]'
                                : 'bg-white border-gray-200 text-gray-600 hover:border-gray-300 hover:bg-gray-50'
                        }`}
                    >
                        {active && <Check className="w-3 h-3 shrink-0" />}
                        {opt.label}
                    </button>
                );
            })}
        </div>
    );
};

export default JobHeaderExperience;
